// --- Hamburger Menu Logic ---
const hamburgerBtn = document.getElementById('hamburger');
const hamburgerNav = document.getElementById('hamburger-nav');
const hamburgerIcon = document.getElementById('hamburger-icon');

function toggleHamburgerMenu() {
    if (!hamburgerBtn || !hamburgerNav || !hamburgerIcon) return; // Guard against missing elements

    const isExpanded = hamburgerBtn.getAttribute('aria-expanded') === 'true';
    hamburgerBtn.setAttribute('aria-expanded', String(!isExpanded)); // Use String() for attribute
    hamburgerNav.classList.toggle('hidden'); // Toggles the display based on presence of 'hidden' class

    // Update icon based on new state (after toggle)
    if (hamburgerNav.classList.contains('hidden')) { // If it IS hidden now (was open)
        hamburgerIcon.src = 'https://cdn.jsdelivr.net/npm/lucide-static@latest/icons/menu.svg';
        hamburgerIcon.alt = 'Menu';
    } else { // If it is NOT hidden now (was closed)
        hamburgerIcon.src = 'https://cdn.jsdelivr.net/npm/lucide-static@latest/icons/x.svg';
        hamburgerIcon.alt = 'Close';
    }
}

function setupEventListeners() {
    if (hamburgerBtn) {
         hamburgerBtn.addEventListener('click', toggleHamburgerMenu);
    }
    // Close menu if clicking outside of it
    document.addEventListener('click', (event) => {
        if (!hamburgerNav || !hamburgerBtn || hamburgerNav.classList.contains('hidden')) {
            // Don't do anything if menu is already hidden or elements don't exist
            return;
        }
        const isClickInsideNav = hamburgerNav.contains(event.target);
        const isClickOnHamburger = hamburgerBtn.contains(event.target);

        // If the click is outside the open nav and not on the button itself
        if (!isClickInsideNav && !isClickOnHamburger) {
            toggleHamburgerMenu(); // Close the menu
        }
    });
}

// Run the setup once the page is loaded
document.addEventListener('DOMContentLoaded', setupEventListeners);